export const selectPageLoader = state => state.pageLoader;

export const selectPageLoaderIsDisplayed = state => {
  const pageLoader = selectPageLoader(state);

  return pageLoader && pageLoader.isDisplayed;
};

export const selectPageLoaderLoaderType = state => {
  const pageLoader = selectPageLoader(state);

  return pageLoader && pageLoader.loaderType;
};
